import React, { type ReactElement } from 'react';

import type { SvgProps } from './types';

import * as styles from './Icons.css';

const MoveIcon = ({
  width = '18px',
  height = '14px',
  weight = 'regular',
  viewbox = '0 0 18 14',
}: SvgProps): ReactElement => {
  const className = weight === 'regular' ? styles.regular : styles.weak;

  return (
    <svg width={width} height={height} viewBox={viewbox} version="1.1">
      <title>Move icon</title>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          transform="translate(-679.000000, -245.000000)"
          strokeWidth="2"
          className={className}
        >
          <g transform="translate(440.000000, 235.000000)">
            <g id="move_active" transform="translate(240.000000, 11.000000)">
              <path
                d="M12,-2 L14,-2 L14,14 L2,14 L2,-2 C2.6697948,-2 3.33958959,-2 4.00938439,-2"
                transform="translate(8.000000, 6.000000) rotate(-90.000000) translate(-8.000000, -6.000000) "
              />
              <path d="M12,6 L0,6" id="Line-3" />
              <polyline
                transform="translate(10.000000, 6.000000) rotate(-90.000000) translate(-10.000000, -6.000000) "
                points="7 4 10 8 13 4"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default MoveIcon;
